import React from 'react';
import Modal from '../shared/Modal';
import {
  maskServiceDateShort,
  maskServiceEndTime,
  maskServiceStartTime
} from '../../masks';

class ChefDeclineOpportunityModal extends React.Component {
  render() {
    const { isOpen, closeModal, onSubmit, opportunity } = this.props;

    if (!opportunity) return '';

    const { service } = this.props.opportunity;

    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal}>
        <h2 className="h2 modal__heading">Are you declining this client?</h2>
        <div className="form__row--spacer">
          <div className="modal__p">
            <p className="p">
              <span className="p--bold">Service Date: </span>
              {maskServiceDateShort(service.start_time)}
            </p>
            <p className="p">
              <span className="p--bold">Time: </span>
              {maskServiceStartTime(service.start_time)}
              {maskServiceEndTime(service.end_time)}
            </p>
            <p className="p">
              <span className="p--bold">Zip Code: </span>
              {service.address.zip_code}
            </p>
          </div>
        </div>
        <div className="form__row">
          <div className="form__row-item form__row-item--half">
            <div
              className="btn btn--hollow-blue btn--full-width"
              onClick={closeModal}
            >
              Cancel
            </div>
          </div>
          <div className="form__row-item form__row-item--half">
            <div
              className="btn btn--solid-blue btn--full-width"
              onClick={onSubmit}
            >
              Submit
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ChefDeclineOpportunityModal;



// WEBPACK FOOTER //
// ./src/components/chef/ChefDeclineOpportunityModal.js